var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconQuestionMark = function SvgIconQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.667,
    height: 16.667,
    x: 0.666,
    y: 0.167,
    fill: "#fff",
    rx: 8.333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M8.271 10.38v-.05c.006-.528.061-.948.166-1.26.105-.312.254-.564.448-.758.193-.193.425-.371.696-.534.163-.1.309-.217.439-.352a1.567 1.567 0 0 0 .422-1.073c0-.271-.063-.506-.19-.705a1.28 1.28 0 0 0-.51-.46 1.545 1.545 0 0 0-.708-.161c-.227 0-.445.047-.655.14-.21.095-.385.242-.526.444-.14.202-.222.465-.245.791H6.564c.023-.47.144-.871.365-1.205.224-.335.518-.59.882-.767a2.782 2.782 0 0 1 1.223-.265c.486 0 .908.097 1.267.29.362.193.641.459.837.795.2.337.299.721.299 1.152 0 .304-.047.579-.141.825a2.032 2.032 0 0 1-.398.658 2.728 2.728 0 0 1-.621.514 2.573 2.573 0 0 0-.585.48 1.518 1.518 0 0 0-.319.593c-.066.23-.102.515-.107.858v.05H8.27Zm.53 2.452a.718.718 0 0 1-.525-.22.718.718 0 0 1-.22-.526c0-.204.073-.38.22-.526a.718.718 0 0 1 .526-.22c.204 0 .38.074.526.22.146.147.22.322.22.526a.773.773 0 0 1-.373.646.71.71 0 0 1-.373.1Z"
  })));
};
export default SvgIconQuestionMark;